var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12C0 5.37259 5.37258 0 12 0C18.6245 0.00717163 23.9928 5.37555 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12ZM17.2387 15.1611C17.3994 15.0738 17.4996 14.9058 17.5 14.723V9.27701C17.4999 9.09393 17.3998 8.92551 17.239 8.83801C17.0781 8.75085 16.8825 8.75854 16.729 8.858L14.886 10.052C14.809 10.1011 14.7113 10.1046 14.631 10.0609C14.5508 10.0172 14.5006 9.93338 14.5 9.84201V8.5C14.5 8.22385 14.2761 8 14 8H7C6.72386 8 6.5 8.22385 6.5 8.5V15.5C6.5 15.7762 6.72386 16 7 16H14C14.2761 16 14.5 15.7762 14.5 15.5V14.158C14.4999 14.0663 14.55 13.982 14.6305 13.9382C14.711 13.8943 14.8091 13.8981 14.886 13.948L16.729 15.142C16.8826 15.2411 17.0781 15.2484 17.2387 15.1611Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilming);
export default __webpack_public_path__ + "static/media/filming.980b3e85.svg";
export { ForwardRef as ReactComponent };